import { GH } from '../theme';

export function SectionLabel({ children }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <span style={{ width: 28, height: 1.5, background: GH.colors.gold, display: 'block', flexShrink: 0 }} />
      <span style={{
        fontFamily: GH.fonts.body, fontSize: 11, fontWeight: 600,
        letterSpacing: '0.16em', textTransform: 'uppercase',
        color: GH.colors.gold,
      }}>{children}</span>
    </div>
  );
}
